/**
 * This is the logout routes configuration.
 * Only configure routes in this file.
 * @memberOf Logout Module
 * @namespace Logout Routes
 */
import logoutTemplate from './logout.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf Logout Module.Logout Routes
 * @ngInject
 */
var config = function ($stateProvider) {
    
    /* Create the logout state and assign the template and controller. */
    $stateProvider
		.state('logout', {
			url: '/logout',
			template: logoutTemplate,
			controller: 'logoutController',
			controllerAs: 'logoutController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/logout/logout.route.js